<template>
    <div id="page">
        <div class="flex pad14 alc" id="toolH">
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="gotoPage('add')">新增</el-button>
            <el-select style="width: 100px;margin-left: 10px" remote :remote-method="remoteMethodkh"   class="marr4" v-model="i_national" size="mini" @clear="cleardatagb" clearable filterable >
                <el-option
                        v-for="item in nalList"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-input
                    style="width: 220px"
                    class="marr4"
                    size="small"
                    placeholder="搜索"
                    clearable
                    v-model="vc_search">
            </el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="toSave">保存</el-button>
        </div>
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :row-class-name="rowClassName">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    width="55">
            </el-table-column>
            <!--<el-table-column
                    type="index"
                    label="客户类型"
                    width="200">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.edit" style="width: 150px" @change="changekhData(scope.row)"  class="marr4" v-model="scope.row.vc_type" size="mini" clearable filterable >
                            <el-option
                                    v-for="item in khList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.vc_name">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_type}}</span>
                    </template>
            </el-table-column>-->
            <el-table-column
                    type="index"
                    label="名称"
                    width="200">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_name">
                    </el-input>
                    <span v-else>{{scope.row.vc_name}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column
                    type="index"
                    label="中文名"
                    width="200">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_name_cn">
                    </el-input>
                    <span v-else>{{scope.row.vc_name_cn}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="index"
                    label="英文名"
                    width="200">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_name_en">
                    </el-input>
                    <span v-else>{{scope.row.vc_name_en}}</span>
                </template>
            </el-table-column>-->
            <el-table-column
                    type="index"
                    label="国别/地区"
                    width="200">
                <template slot-scope="scope">
                    <el-select v-if="scope.row.edit" style="width: 150px" remote :remote-method="remoteMethodkh2"  @change="changegbData(scope.row)"  class="marr4" v-model="scope.row.vc_national" size="mini" @clear="cleardata(scope.row)" clearable  filterable >
                        <el-option
                                v-for="item in nalList2"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                    <span v-else>{{scope.row.vc_national}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column
                    type="vc_credit_insurance"
                    label="信保代码"
                    width="200">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_credit_insurance">
                    </el-input>
                    <span v-else>{{scope.row.vc_credit_insurance}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="f_credit_insurance"
                    label="信保额度"
                    width="200">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.f_credit_insurance">
                    </el-input>
                    <span v-else>{{scope.row.f_credit_insurance}}</span>
                </template>
            </el-table-column>-->
            <el-table-column
                    type="isuse"
                    label="状态"
                    width="180">
                <template slot-scope="scope">
                    <el-radio-group v-if="scope.row.edit" v-removeAria v-model="scope.row.isuse">
                        <el-radio :label='0'>禁用</el-radio>
                        <el-radio :label='1'>启用</el-radio>
                    </el-radio-group>
                    <span v-else>{{scope.row.isuse==1?'启用':'禁用'}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column
                    type="vc_ywuname"
                    label="业务员"
                    width="200">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_ywuname">
                    </el-input>
                    <span v-else>{{scope.row.vc_ywuname}}</span>
                </template>
            </el-table-column>-->
            <el-table-column
                    width="60"
                    label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.edit==false"  type="text" size="small" @click="goEdit(tableData,scope.$index,scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div :class="baseerp+'div'" class="cgdia">
            <el-dialog
                    width="500px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
<!--                <add-page :data="addData" @close="cancelDialog"></add-page>-->
            </el-dialog>
        </div>
    </div>

</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    //import addPage from "./addPage";
    export default {
        components: {
            //addPage
        },
        data() {
            return {
                khList:[],
                nalList:[],
                nalList2:[],
                i_national:0,
                vc_national:'全部',
                vc_search:"",
                addData:{},
                title:'新增',
                dialogVisible:false,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                baseerp:"",
                file_root:"",
                mid:0,
                tableData:[
                ],
                loading:false,
                tableHeight:0,
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            //this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root = file_root;
            this.nationalList(1,'');
            this.nationalList(2,'');
            //this.khtypeList();
            this.getlist();
            this.$nextTick(function () {
                this.onResize();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                //console.log(n.h,this.tableHeight)
            },
            toSave(){
                let arr=[];
                arr=this.tableData.filter(item=>{
                    return item.edit==true
                })
                //console.log(arr,'arr')
                this.save(arr);
            },
            //
            async save(arr){
                this.loading=true;
                let param={
                    list:arr,
                };
                let res=await API.companysave(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.getlist();
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.getlist();
                    this.$message.error(res.message);
                }
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getlist();
            },
            cancelDialog(){
                this.dialogVisible=false;
            },
            goEdit(data,index,row){
                row.edit=true;
                this.$set(data,index,row)
            },
            gotoPage(type){
                let map={
                    i_id:0,
                    isuse:1,
                    edit:true,
                }
                this.tableData.push(map);
                /*if(type=='add'){
                    this.addData={
                        i_id:0,
                    }
                }
                this.dialogVisible=true;*/
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getlist()
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getlist()
            },
            remoteMethodkh(val){
                this.nationalList(1,val);
            },
            remoteMethodkh2(val){
                this.nationalList(2,val);
            },
            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },
            /*changekhData(e){
                console.log(e.index);
                if(this.khList.length!=0){
                    let choo = this.khList.filter(item=>{
                        return item.vc_name == e.vc_type
                    });
                    console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].vc_type=choo[0].vc_name;
                        this.tableData[e.index].i_type=choo[0].i_id;
                    }else{
                        this.tableData[e.index].vc_type='';
                        this.tableData[e.index].i_type=0;
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                }
            },*/
            cleardatagb(){
                this.nationalList(1,'');
            },
            cleardata(e){
                //console.log(e,'e')
                this.nationalList(2,'')
            },
            changegbData(e){
                //console.log(e);
                if(this.nalList2.length!=0){
                    let choo = this.nalList2.filter(item=>{
                        return item.vc_name == e.vc_national
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].vc_national=choo[0].vc_name;
                        this.tableData[e.index].i_national=choo[0].i_id;
                    }else{
                        this.tableData[e.index].vc_national='';
                        this.tableData[e.index].i_national=0;
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                }
            },
            //下拉框国别
            async nationalList(type,val){
                let param = {
                    i_mid:this.mid,
                    vc_search:val,
                    currentPage:1,
                    pageSize:50,
                    isuse:1,
                };
                /*let res={
                    code:1
                }*/
                let res = await API.nationalList(param);
                if (res.code == 1) {
                    if(type==1){
                        //this.nalList=[{i_id:1,vc_name:'数税云'},{i_id:2,vc_name:'线下'},{i_id:0,vc_name:'全部'}];
                        this.nalList = res.data.list;
                        this.nalList.unshift({i_id:0,vc_name:'全部'});
                    }
                    if(type==2){
                        //this.nalList=[{i_id:1,vc_name:'数税云'},{i_id:2,vc_name:'线下'},{i_id:0,vc_name:'全部'}];
                        this.nalList2 = res.data.list;
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //
            /*async khtypeList(){
                let param = {
                    i_mid:this.mid,
                };
                /!*let res={
                    code:1
                }*!/
                let res = await API.khtypeList(param);
                if (res.code == 1) {
                    //this.khList=[{i_id:1,vc_name:'数税云'},{i_id:2,vc_name:'线下'},{i_id:0,vc_name:'全部'}];
                    this.khList = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },*/
            async getlist(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid:this.mid,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    i_national:this.i_national,
                    vc_search:this.vc_search,
                };
                //console.log(param,'param');
                let res=await API.companylist(param);
                if ( res.code == 1 ){
                    res.data.list.map(item=>{
                        item.edit=false;
                    })
                    this.tableData=res.data.list;
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style  lang="scss" scoped>

    .alc{
        align-items: center;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:58px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>